import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import type { NonGenerativeAIAnswerResultShownProps } from './types';

// Tracking when the jira nl to jql card was loaded. Includes both failures and success.
export const onJiraNlToJqlCardLoaded: ({
	searchSessionId,
	queryHash,
	brand,
	source,
	query,
	loadTime,
	success,
	answerCardType,
	answerString,
	endState,
	queryIntent,
	jiraNlToJqlCardVariant,
	nlToJqlLoadTime,
	issueSearchLoadTime,
	phaseTimingSource,
}: NonGenerativeAIAnswerResultShownProps & {
	loadTime?: number;
	success: boolean;
	endState?: 'answered' | 'no-issues' | 'jql-error' | 'issues-error' | 'datasource-timeout';
	jiraNlToJqlCardVariant?: 'issue-table' | 'smartlink';
	nlToJqlLoadTime?: number;
	issueSearchLoadTime?: number;
	phaseTimingSource?: 'measured' | 'derived';
}) => AnalyticsEventPayload = ({
	searchSessionId,
	queryHash,
	brand,
	source,
	query,
	loadTime,
	success,
	answerCardType,
	answerString,
	endState,
	queryIntent,
	jiraNlToJqlCardVariant,
	nlToJqlLoadTime,
	issueSearchLoadTime,
	phaseTimingSource,
}: NonGenerativeAIAnswerResultShownProps & {
	loadTime?: number;
	success: boolean;
	endState?: 'answered' | 'no-issues' | 'jql-error' | 'issues-error' | 'datasource-timeout';
	jiraNlToJqlCardVariant?: 'issue-table' | 'smartlink';
	nlToJqlLoadTime?: number;
	issueSearchLoadTime?: number;
	phaseTimingSource?: 'measured' | 'derived';
}): AnalyticsEventPayload => {
	return {
		action: 'loaded',
		actionSubject: 'aiAnswerJiraNlToJqlCard',
		source,
		eventType: 'track',
		attributes: {
			searchSessionId,
			queryHash,
			brand,
			source,
			loadTime,
			success,
			answerCardType,
			endState,
			queryIntent,
			jiraNlToJqlCardVariant,
			nlToJqlLoadTime,
			issueSearchLoadTime,
			phaseTimingSource,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
